export default {
  // Définir ici les URL des services à appeler (possibilité d'avoir des pathParam)
  // getXXX: '/get/{id}'
  getChainesLocales: 'api/reamenagementChaines?adresse={adresseInsee}&codeinsee={codeInsee}',
  getMultiplex: '/api/multiplex.json',
  getAntennisteList: '/api/antennistes/getAllAntenniste?numeroanfr={numeroAnfr}&rayon={rayonMax}',
  getTypePerturbation: '/api/typeprtvperturbation.json',
  getTypeDefaut: '/api/typeprtvdefaut.json',
  searchCommune: '/api/communes/nom.json',
  searchCodepostal: '/api/communes/codepostal.json',
  searchEmetteurTnt: '/api/emetteurtnt.json',
  getMessageCommune: '/api/messages/getmessagecommune',
  getAntenneLTEPerturbation: '/api/perturbation_lte',
  postPrtv: '/api/reclamation_prtv/create',
  updatePrtv: '/api/reclamation_prtv/update',
  updatePrtvWithFactureAntenniste: '/api/reclamation_prtv/updateWithFacture',
  updatePrtvDemandeEnquete: '/api/reclamation_prtv/updateDemandeEnquete',
  postLte: '/api/reclamation_lte/create',
  getPrtvPdf: '/api/reclamation_prtv/pdf',
  searchSuspicionLte: '/api/emetteurlte/suspicionlte?voie={concatVoie}&codepostal={codePostal}&commune={nomCommune}',
  getReamenagement: '/api/reamenagement',
  checkDossier: '/api/reclamation_prtv/suividossier?numeroanfr={numeroAnfr}&codepostal={codePostal}&nom={nomUser}&prenom={prenomUser}',
  remplirDemande: '/api/reclamation_prtv/remplirdemandeenquete?numeroanfr={numeroAnfr}&checkcode={checkCode}&accept={accepter}',
  imprimerDemande: '/api/reclamation_prtv/impressiondemandeenquete?numeroanfr={numeroAnfr}&checkcode={checkCode}&impressionde={impressionDe}'
};



// WEBPACK FOOTER //
// ./src/configuration.js